/* esm.sh - applesauce-core@5.2.0/dist/helpers/url */
export * from "/*applesauce-core@5.2.0/esnext/dist/helpers/url.mjs";
